import styles from "./CardsContainer.module.scss";

import { Container, Props as ContainerProps } from "../container/Container";

export const CardsContainer = (props: Omit<ContainerProps, "defaultStyle">) => {
    return <Container {...props} defaultStyle={styles.container} />;
};
